import React from 'react';
import styled from 'styled-components';

import DeleteButton from '../../common/DeleteButton';

const StyledSpan = styled.div`
  font-weight: bold;
`;

const TemplateDelete = ({ templateName, onDelete, isCloseClick }) => (
  <DeleteButton isCloseClick={isCloseClick} onDelete={onDelete}>
    <div>
      Are you sure to permanently delete
      <StyledSpan>{` ${templateName} `}</StyledSpan>
      template?
    </div>
  </DeleteButton>
);

export default TemplateDelete;
